module.exports = __webpack_public_path__ + "static/img/circle@2x.24ec7007.png";